// extracted by mini-css-extract-plugin
export var linkMuted = "index-module--link-muted--3u-7I";